export const CONSONANT_VOWEL_PAIRS_TT = [

    // ㄸ
  {
        id: 1,
        korean: "따",
        english: "tta",

    },
    {
        id: 2,
        korean: "떼",
        english: "tte",

    },
    {
        id: 3,
        korean: "띠",
        english: "tti",

    },
    {
        id: 4,
        korean: "또",
        english: "tto",

    },
    {
        id: 5,
        korean: "뜨",
        english: "tteu",

    },
    {
        id: 6,
        korean: "떠",
        english: "tteo",

    },
    {
        id: 7,
        korean: "땨",
        english: "ttya",

    },
    {
        id: 8,
        korean: "때",
        english: "ttae",

    },
    {
        id: 9,
        korean: "뗴",
        english: "ttye",

    },
    {
        id: 10,
        korean: "뚀",
        english: "ttyo",

    },
    {
        id: 11,
        korean: "뗘",
        english: "ttyeo",

    },
    {
        id: 12,
        korean: "뜌",
        english: "ttyu",

        

    },

    {
        id: 13,
        korean: "딴",
        english: "ttan",

        

    },
    {
        id: 14,
        korean: "딱",
        english: "ttak",

        

    },
    {
        id: 15,
        korean: "띰",
        english: "ttim",
        

    },
    {
        id: 16,
        korean: "땃",
        english: "ttat",
        

    },
    {
        id: 17,
        korean: "땋",
        english: "ttah",
        

    },
    {
        id: 18,
        korean: "떱",
        english: "tteob",
        

    },
          {
        id: 19,
        korean: "뜰",
        english: "tteul",
        

    },
    {
        id: 20,
        korean: "땉",
        english: "ttat",
        

    },
    {
        id: 21,
        korean: "땎",
        english: "ttaekk",
        

    },
    {
        id: 22,
        korean: "땐",
        english: "ttaen",
        

    },
    {
        id: 23,
        korean: "띄",
        english: "ttui",
        

    },
    {
        id: 24,
        korean: "뚸",
        english: "ttwo",
        

    },

    {
        id: 25,
        korean: "떁",
        english: "ttyat",
        

    },
    {
        id: 26,
        korean: "땃",
        english: "ttat",
        

    },
    {
        id: 27,
        korean: "땆",
        english: "ttat",
        
    },
    {
        id: 28,
        korean: "뜜",
        english: "tyum",
        
    },
    {
        id: 29,
        korean: "땆",
        english: "ttat",
        
    },
    {
        id: 30,
        korean: "땆",
        english: "ttat",
        
    },
    
    
    
];

